/* eslint-disable no-template-curly-in-string */
import * as Yup from 'yup'
import { i18n } from '~/i18n'

const PHONE_NUMBER_REGEX = /^\s*(?:\+?(\d{1,3}))?([-. (]*(\d{3})[-. )]*)?((\d{3})[-. ]*(\d{2,4})(?:[-.x ]*(\d+))?)\s*$/
const VALIDATIONS_NAMESPACE = 'validations'

Yup.addMethod(Yup.string, 'phone', function validatePhoneNumber() {
  return this.matches(PHONE_NUMBER_REGEX, {
    message: '${path} must be a valid phone number e.g. 12025550159',
  })
})

Yup.addMethod(Yup.string, 'json', function validateJson() {
  return this.test('isJson', '${path} must be a valid json', (value) => {
    if (value) {
      try {
        JSON.parse(value)
      } catch {
        return false
      }
    }
    return true
  })
})

Yup.setLocale({
  mixed: {
    required: (options) => {
      const key = `validations.labels.${options.label}`
      const translatedLabel = i18n.t(key, { ns: VALIDATIONS_NAMESPACE })
      if (translatedLabel.includes(key)) {
        return `${options.label} is a required field`
      }

      const message = i18n.t('validations.messages.required', {
        ns: VALIDATIONS_NAMESPACE,
        label: translatedLabel,
      })

      return message
    },
    oneOf: ({ path }) => {
      let message
      if (path === 'passwordConfirmation') {
        message = i18n.t('validations.messages.notMatchesPassword', { ns: VALIDATIONS_NAMESPACE })
      }

      return message
    },
  },
  string: {
    email: () => {
      const message = i18n.t('validations.messages.email', { ns: VALIDATIONS_NAMESPACE })
      return message
    },
  },
})
